import { type JSX, lazy, memo, Suspense, useRef } from 'react';

import { ErrorBoundaryWithRetry } from '@/_components';

import { Loading } from './loading';
import type { RevisionHistorySectionProps } from './shared';

function RevisionHistorySectionBase<T, Tf>(props: RevisionHistorySectionProps<T, Tf>) {
  const ref = useRef(true);

  const rh = useRef<JSX.Element | null>(null);
  if (ref.current) {
    ref.current = false;
    const RevisionHistory = lazy(() => import('./revision-history')) as React.LazyExoticComponent<
      React.FC<RevisionHistorySectionProps<T, Tf>>
    >;
    rh.current = <RevisionHistory {...props} />;
  }

  return (
    <ErrorBoundaryWithRetry>
      <Suspense fallback={<Loading />}>{rh.current}</Suspense>
    </ErrorBoundaryWithRetry>
  );
}

export const RevisionHistorySection = memo(RevisionHistorySectionBase) as <T, Tf>(
  props: RevisionHistorySectionProps<T, Tf>
) => JSX.Element;
